import React, {useEffect, useState} from "react";
import Topbar from "../../layout/Topbar";
import SettingsSidebar from "../SettingsSidebar";
import {connect} from "react-redux";
import CustomSnackbar from "../../alert/CustomSnackbar";
import {
    Box,
    Button, CssBaseline,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Link, Typography, IconButton
} from "@mui/material";
import Spinner from "../../spinner/Spinner";
import moment from "moment-timezone";
import {apiAccessActions} from "../../../store/actions/apiAccessAction";
import CopyContentToClipboard from "../../utils/CopyContentToClipboard";
import {VpnKeyOutlined, Add, OpenInNew, DeleteOutlined} from "@mui/icons-material";
import CreateAccessTokenForm from "./CreateAccessTokenForm";
import {adsManagerPublicAPIDoc} from "../../../helpers/config";
import {SettingsContentBox, SettingsRoot} from "../General";
import {settingsPageStyles, SettingsPageHeader, SettingsEmptyState, getSettingsColors} from "../SettingsDesign";

function ApiAccess(props) {

    const {apiAccess} = props.state;

    const [open, setOpen] = useState(false);
    const handleOnClose = () => setOpen(false);
    const handleOnClick = () => setOpen(true);

    useEffect(() => {
        if (apiAccess?.reload) {
            props.fetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiAccess?.reload]);

    useEffect(() => {
        props.fetch(); // load only once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <SettingsRoot>
        <CssBaseline/>
        <Topbar/>
        <SettingsSidebar {...props}/>
        <SettingsContentBox sx={[settingsPageStyles, {'& .MuiTableContainer-root': {border: 0}}]}>
            <Box sx={{width: '100%', maxWidth: 1280, minWidth: 0, mx: 'auto', px: {xs: 0, sm: 3.75}, pt: 3}}>
                {props.state.alert.errorMsg && <CustomSnackbar message={props.state.alert.errorMsg}/>}
                {props.state.alert.successMsg && <CustomSnackbar message={props.state.alert.successMsg} severity="success"/>}
                <SettingsPageHeader title="API Access"/>
                <Paper elevation={0} sx={{minHeight: 200}}>
                    <Box sx={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 2.5}}>
                        <Box>
                            <Typography component="h2" sx={{fontSize: 16, fontWeight: 600, whiteSpace: 'normal'}}>Access tokens</Typography>
                            <Typography sx={{fontSize: 13, color: 'text.secondary', whiteSpace: 'normal', mt: 0.75}}>Connect your tools to campaign management and reporting.</Typography>
                        </Box>
                        <Button variant="contained" startIcon={<Add/>} onClick={handleOnClick}>Create token</Button>
                    </Box>
                    <Box sx={{bgcolor: theme => getSettingsColors(theme).inset, borderRadius: '10px', p: 2, mb: 2.5,
                        display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: 2}}>
                        <Box sx={{minWidth: 0, flex: '1 1 260px'}}>
                            <Typography sx={{fontSize: 13, color: 'text.secondary', whiteSpace: 'normal'}}>Manage campaigns, traffic sources, affiliate networks, offers, and landings, and retrieve detailed campaign statistics.</Typography>
                            <Typography sx={{fontSize: 12, color: 'text.secondary', whiteSpace: 'normal', mt: 1}}>Up to 10 tokens · Valid for 1 year</Typography>
                        </Box>
                        <Link href={adsManagerPublicAPIDoc} target="_blank" rel="noreferrer" underline="hover"
                            sx={{display: 'inline-flex', alignItems: 'center', gap: 0.75, fontSize: 13, fontWeight: 500}}>
                            API documentation <OpenInNew sx={{fontSize: 16}}/>
                        </Link>
                    </Box>
                    {apiAccess?.loading?.keys && <Spinner overComponentBox noBackShadow/>}
                    {apiAccess?.keys?.length > 0 ? <TableContainer sx={{maxHeight: 400, overflow: 'auto'}}>
                        <Table stickyHeader size="small" aria-label="API access tokens">
                            <TableHead><TableRow>
                                <TableCell>Name</TableCell><TableCell>Key</TableCell><TableCell>Created (UTC)</TableCell>
                                <TableCell>Expires (UTC)</TableCell><TableCell align="right">Actions</TableCell>
                            </TableRow></TableHead>
                            <TableBody sx={{whiteSpace: 'nowrap'}}>
                                {apiAccess.keys.map(row => <TableRow key={row.id}>
                                    <TableCell sx={{fontWeight: 500}}>{row.name}</TableCell>
                                    <TableCell sx={{minWidth: 240, maxWidth: 350, overflow: 'hidden', textOverflow: 'ellipsis'}}><CopyContentToClipboard copyText={row.jwt} compact/></TableCell>
                                    <TableCell>{moment.utc(row.createdAt).format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                                    <TableCell>{moment.utc(row.expiresAt).format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                                    <TableCell align="right"><Tooltip title="Revoke token"><IconButton color="error" size="small"
                                        aria-label={`Revoke ${row.name}`} onClick={() => props.remove(row.id)}><DeleteOutlined color="error" fontSize="small"/></IconButton></Tooltip></TableCell>
                                </TableRow>)}
                            </TableBody>
                        </Table>
                    </TableContainer> : !apiAccess?.loading?.keys && <SettingsEmptyState icon={VpnKeyOutlined} title="No access tokens yet"
                        description="Create an access token to connect your tools to Skro."/>}
                </Paper>
                {open && <CreateAccessTokenForm open onClose={handleOnClose}/>}
            </Box>
        </SettingsContentBox>
    </SettingsRoot>;
}

const mapStateToProps = (state) => {
    return {
        state: {
            alert: state.alert,
            apiAccess: state.apiAccess,
        }
    };
};

const mapDispatchToProps = {
    fetch: apiAccessActions.fetch,
    remove: apiAccessActions.revoke,
};

export default connect(mapStateToProps, mapDispatchToProps)(ApiAccess);
